/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_SYNC_RESOURCE_CONNECT_MODAL } from 'state/action-types';

import { createReducer } from 'state/utils';

export const resourceConnectId = createReducer(null, {
    [START_SYNC_RESOURCE_CONNECT_MODAL]: (state, { payload }) => payload.resourceConnectId,
});

export default combineReducers({
    resourceConnectId,
});
